package com.milta.core.localization.translations.bg

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Обнови",
    expandedStopsTitle = "Спирки",
    stopStatusWaitingLabel = "В очакване",
    stopStatusFailedLabel = "Недоставено",
    filterAllDriversLabel = "Всички шофьори",
)
